import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import printBaggageTag from '../../../../utils/printers/BaggageTicket';
import { flagPrintBaggageVoucher } from '../../../../actions';

const PrintBaggageTicketButton = ({ baggage, dispatchFlagPrintBaggageVoucher, printOnMount }) => {
  const handleClick = async () => {
    dispatchFlagPrintBaggageVoucher(true)
    await printBaggageTag(baggage.toJS());
    setTimeout(()=>{dispatchFlagPrintBaggageVoucher(false)},3000)
  };

  return (
    <Button color="light" className="border" onClick={handleClick} disabled={printOnMount}>
      <i className={`fa ${printOnMount ? "fa-spinner" : "fa-print"}`} /> Equipaje
    </Button>
  );
};

PrintBaggageTicketButton.propTypes = {
  baggage: PropTypes.instanceOf(Map).isRequired,
  dispatchFlagPrintBaggageVoucher: PropTypes.func.isRequired,
  printOnMount: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  baggage: BaggageUnit.Baggage.getIn(['current', 'content']),
  printOnMount: BaggageUnit.Baggage.getIn(['current', 'printOnMount']),
});

const mapDispatchToProps = {
  dispatchFlagPrintBaggageVoucher: flagPrintBaggageVoucher,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintBaggageTicketButton);
